import React from 'react';

import { without } from 'lodash';
import { useModelState } from '@utils/widget-model';
import { FeatureId } from '@models/feature';
import { FeatureLikes, FeatureLike } from '../../../feature/feature-likes';
import { FeatureLeaderboardWidgetState } from '../../FeatureLeaderboardWidget';

export const FeatureLeaderboardFeatureLikes = ({
  featureId,
}: {
  featureId: FeatureId;
}) => {
  const [likedFeatures, setLikedFeatures] = useModelState<
    FeatureLeaderboardWidgetState,
    'liked_features'
  >('liked_features');
  const [dislikedFeatures, setDislikedFeatures] = useModelState<
    FeatureLeaderboardWidgetState,
    'disliked_features'
  >('disliked_features');

  const [liked, setLiked] = React.useState<FeatureLike>(
    () => FeatureLike.Neutral
  );

  React.useEffect(() => {
    const newState = likedFeatures.includes(featureId)
      ? FeatureLike.Liked
      : dislikedFeatures.includes(featureId)
      ? FeatureLike.Disliked
      : FeatureLike.Neutral;

    setLiked(newState);
  }, [likedFeatures, dislikedFeatures]);

  function toggleIsLiked() {
    if (liked === FeatureLike.Neutral) {
      setLikedFeatures([...likedFeatures, featureId]);
    }
    if (liked === FeatureLike.Liked) {
      setLikedFeatures(without(likedFeatures, featureId));
    }
    if (liked === FeatureLike.Disliked) {
      setDislikedFeatures(without(dislikedFeatures, featureId));
      setLikedFeatures([...likedFeatures, featureId]);
    }
  }

  function toggleIsDisliked() {
    if (liked === FeatureLike.Neutral) {
      setDislikedFeatures([...dislikedFeatures, featureId]);
    }
    if (liked === FeatureLike.Disliked) {
      setDislikedFeatures(without(dislikedFeatures, featureId));
    }
    if (liked === FeatureLike.Liked) {
      setLikedFeatures(without(likedFeatures, featureId));
      setDislikedFeatures([...dislikedFeatures, featureId]);
    }
  }

  return (
    <FeatureLikes
      liked={liked}
      toggleIsLiked={toggleIsLiked}
      toggleIsDisliked={toggleIsDisliked}
    />
  );
};
